"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotion = require("emotion");

var _lodash = require("lodash");

var _window = _interopRequireDefault(require("global/window"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  font-family: Helvetica, Arial, sans-serif;\n  font-size: 14px;\n  position: absolute;\n  padding: 4px;\n  margin: 8px;\n  background: rgba(0, 0, 0, 0.75);\n  color: #ffffff;\n  max-width: 250px;\n  z-index: 9;\n  pointer-events: none;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var tooltip = (0, _emotion.css)(_templateObject());

var MapTooltip = function MapTooltip(props) {
  var tooltipInfo = props.tooltipInfo,
      x = props.x,
      y = props.y,
      primaryName = props.primaryName,
      primaryField = props.primaryField,
      secondaryName = props.secondaryName,
      secondaryField = props.secondaryField,
      isHex = props.isHex;
  var xPosition = x < (0, _lodash.get)(_window["default"], "innerWidth", 1000) * 0.66 ? x : x - (0, _lodash.get)(_window["default"], "innerWidth", 1000) * 0.1;
  var yPostition = y < 375 ? y : y - 50;
  return _react["default"].createElement("div", {
    className: tooltip,
    style: {
      left: xPosition,
      top: yPostition
    }
  }, primaryName ? _react["default"].createElement("div", null, primaryName, ": ", tooltipInfo.properties[primaryField]) : null, secondaryName ? _react["default"].createElement("div", null, secondaryName, ": ", tooltipInfo.properties[secondaryField]) : null, isHex ? _react["default"].createElement("div", null, _react["default"].createElement("div", null, "elevation: ", tooltipInfo.elevationValue), _react["default"].createElement("div", null, "coordinates: ", tooltipInfo.centroid.join(", "))) : null);
};

MapTooltip.propTypes = {
  tooltipInfo: _propTypes["default"].shape({}),
  x: _propTypes["default"].number,
  y: _propTypes["default"].number,
  primaryName: _propTypes["default"].string,
  primaryField: _propTypes["default"].string,
  secondaryName: _propTypes["default"].string,
  secondaryField: _propTypes["default"].string,
  isHex: _propTypes["default"].bool
};
var _default = MapTooltip;
exports["default"] = _default;